import "vant/es/image/style";
import _Image from "vant/es/image";
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/help/fire.png';

const _withScopeId = n => (_pushScopeId("data-v-6758623d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "content-wrap"
};
const _hoisted_2 = {
  class: "info-wrap"
};
const _hoisted_3 = {
  class: "source"
};
const _hoisted_4 = {
  class: "date"
};
const _hoisted_5 = {
  class: "heatCount"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "fire",
  src: _imports_0,
  alt: ""
}, null, -1));

import composition from '@/composition';
export default {
  props: {
    news: Object,
    islist: Boolean
  },

  setup(__props) {
    const {
      openNews,
      formatTime
    } = composition();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "news-cell",
        onClick: _cache[0] || (_cache[0] = $event => _unref(openNews)(__props.news.newsId))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", {
        class: _normalizeClass(['title-text', __props.islist ? 'light-title-text' : ''])
      }, _toDisplayString(__props.news.title), 3), __props.news.coverImagePath ? (_openBlock(), _createBlock(_unref(_Image), {
        key: 0,
        class: "cover-img",
        fit: "cover",
        src: __props.news.coverImagePath,
        Lazyload: ""
      }, null, 8, ["src"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(__props.news.source), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(formatTime)(__props.news.publishTime)), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(__props.news.heatCount), 1), _hoisted_6])]);
    };
  }

};